
/*
* @Author: syyoon@yongtrim.com 
* @Date: 2018-07-09 17:24:34 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-10-25 22:23:19
*/

import { ImageService } from "../services/image.service";


export function dateStringToClientString(dateString) {
  if (!dateString)
    return '';
  
  const date = new Date(dateString);
  return new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000)).toISOString();
}

export function daetStringToServerString(dateString) {
  if (!dateString)
    return '';
  const date = new Date(dateString);
  return new Date(date.getTime() + (date.getTimezoneOffset() * 60 * 1000)).toISOString();
}

/**
   * Simply compares two string version values.
   *
   * Example:
   * versionCompare('1.1', '1.2') => -1
   * versionCompare('1.1', '1.1') =>  0
   * versionCompare('1.2', '1.1') =>  1
   * versionCompare('2.23.3', '2.22.3') => 1
   *
   * Returns:
   * -1 = left is LOWER than right
   *  0 = they are equal
   *  1 = left is GREATER = right is LOWER
   *  And FALSE if one of input versions are not valid
   *
   * @function
   * @param {String} left  Version #1
   * @param {String} right Version #2
   * @return {Integer|Boolean}
   * @author Alexey Bass (albass)
   * @since 2011-07-14
   */
export function versionCompare(left: string, right: string, full: boolean): number {
  let a: string[] = left.split('.')
    , b: string[] = right.split('.')
    , i: number = 0, len: number = 3;

  if (!full)
    len = 2;

  for (; i < len; i++) {
    if ((a[i] && !b[i] && parseInt(a[i]) > 0) || (parseInt(a[i]) > parseInt(b[i]))) {
      return 1;
    } else if ((b[i] && !a[i] && parseInt(b[i]) > 0) || (parseInt(a[i]) < parseInt(b[i]))) {
      return -1;
    }
  }
  return 0;
}


export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}



export function getUserProfileUrl(patternId: string, photoId: string, photoUrl: string, imageService: ImageService) {
  if (patternId) {
    return `assets/pattern/pattern-${patternId}.svg`;
  } else if (photoId) {
    return imageService.getResizedUrl(photoId, 's');
  } else if (photoUrl) {
    return photoUrl;
  }
  return '';
}

export function getTimesDisp(_seconds) {
  if (_seconds === 0)
    return '00:00';
  _seconds = Math.round(_seconds);
  const seconds = _seconds || 0;
  const minutesStr = '0' + Math.floor(seconds / 60);
  const secondsStr = '0' + (seconds - +minutesStr * 60);
  return minutesStr.substr(-2) + ":" + secondsStr.substr(-2);
}


export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


export function genUniqName() {
  return '' + new Date().getDate() + new Date().getMonth() + new Date().getFullYear() + new Date().getHours() + new Date().getMinutes() + new Date().getSeconds();
}


// WEBPACK FOOTER //
// ./src/common/utils.ts